import { API_BASE_URL } from '../api';

export function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String?.length || 0) % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

/**
 * Регистрира service worker, иска разрешение и записва Web Push абонамент в API.
 */
export async function subscribeDriverWebPush() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator) || !('PushManager' in window)) {
    return { ok: false, reason: 'unsupported' };
  }

  try {
    const perm = await Notification.requestPermission();
    if (perm !== 'granted') {
      return { ok: false, reason: 'denied' };
    }

    // When deployed under a subdirectory (e.g. /workwisesoft/), iOS PWAs require the SW
    // to be registered under the same scope. PUBLIC_URL may be empty in some builds,
    // so we derive the base path from the current location.
    const pub = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
    const basePath =
      pub ||
      (window.location.pathname.startsWith('/workwisesoft')
        ? '/workwisesoft'
        : '');
    const swUrl = `${basePath}/sw.js`;
    const reg = await navigator.serviceWorker.register(swUrl, { scope: `${basePath}/` });

    const vapidRes = await fetch(`${API_BASE_URL}public/vapid-public-key`, {
      headers: { Accept: 'application/json' },
    });
    if (!vapidRes.ok) {
      return { ok: false, reason: 'no_vapid', status: vapidRes.status };
    }
    const body = await vapidRes.json();
    const publicKey = body.publicKey;
    if (!publicKey) {
      return { ok: false, reason: 'no_vapid' };
    }

    const sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });

    const token = localStorage.getItem('token');
    const save = await fetch(`${API_BASE_URL}users/web-push-subscription`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ subscription: sub.toJSON() }),
    });

    if (!save.ok) {
      const text = await save.text().catch(() => '');
      return { ok: false, reason: 'save_failed', status: save.status, body: text?.slice(0, 400) };
    }

    return { ok: true };
  } catch (e) {
    return { ok: false, reason: 'exception', message: String(e?.message || e) };
  }
}
